function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "btn_fullscreen");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M36.3619909,0 C38.3712079,0 40,1.63008294 40,3.63800909 L40,36.3619909 C40,38.3712079 38.369917,40 36.3619909,40 L3.63800909,40 C1.62879215,40 0,38.369917 0,36.3619909 L0,3.63800909 C0,1.62879215 1.63008294,0 3.63800909,0 L36.3619909,0 L36.3619909,0 Z M23.4323388,33.4512618 L33.5316148,33.5316148 L33.4512618,23.4323388 L29.7818061,23.4055545 L29.8164682,27.2451709 L23.9349337,21.3636364 L21.3636364,23.9349337 L27.2451709,29.8164682 L23.4055545,29.7818061 L23.4323388,33.4512618 L23.4323388,33.4512618 Z M16.4629124,6.44398941 L6.36363636,6.36363636 L6.44398941,16.4629124 L10.113445,16.4896967 L10.078783,12.6500803 L15.9603175,18.5316148 L18.5316148,15.9603175 L12.6500803,10.078783 L16.4896967,10.113445 L16.4629124,6.44398941 L16.4629124,6.44398941 Z",
  id: "path-1"
}), React.createElement("filter", {
  x: "-2.5%",
  y: "-2.5%",
  width: "110.0%",
  height: "110.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, React.createElement("feOffset", {
  dx: 1,
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Fordypningsskjermer",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.7
}, React.createElement("g", {
  id: "06_artikkelmal",
  transform: "translate(-1170.000000, -1640.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "btn_fullscreen",
  transform: "translate(1170.000000, 1640.000000)"
}, React.createElement("g", {
  id: "Shape"
}, React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-2)",
  xlinkHref: "#path-1"
}), React.createElement("use", {
  fill: "#FFFFFF",
  xlinkHref: "#path-1"
})))));

var SvgBtnFullscreen = function SvgBtnFullscreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBtnFullscreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/btn-fullscreen.5880a939.svg";
export { ForwardRef as ReactComponent };